(function () {
  if (window.__mmgBagsmagHomeReady) return;
  window.__mmgBagsmagHomeReady = true;

  function getTrack(button) {
    var section = button.closest('[data-mmg-bagsmag-hero]');
    return section ? section.querySelector('[data-mmg-bagsmag-hero-track]') : null;
  }

  function getSliderStep(track) {
    var first = track.children[0];
    var second = track.children[1];

    if (first && second) {
      return Math.max(second.offsetLeft - first.offsetLeft, first.getBoundingClientRect().width || 1);
    }

    return Math.max(track.clientWidth, 1);
  }

  function getSliderMaxIndex(track) {
    var step = getSliderStep(track);
    var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
    return Math.max(Math.round(maxScroll / step), 0);
  }

  function getSliderIndex(track) {
    var step = getSliderStep(track);
    return Math.max(0, Math.min(Math.round(track.scrollLeft / step), getSliderMaxIndex(track)));
  }

  function updateDots(section) {
    var track = section.querySelector('[data-mmg-bagsmag-slider-track]');
    var dots = section.querySelectorAll('[data-mmg-bagsmag-slider-dot]');
    var controls = section.querySelector('[data-mmg-bagsmag-slider-controls]');
    var prevButton = section.querySelector('[data-mmg-bagsmag-slider-nav="prev"]');
    var nextButton = section.querySelector('[data-mmg-bagsmag-slider-nav="next"]');
    if (!track || !dots.length) return;

    var index = getSliderIndex(track);
    var maxIndex = getSliderMaxIndex(track);

    if (controls) controls.hidden = maxIndex < 1;
    if (prevButton) prevButton.disabled = maxIndex < 1;
    if (nextButton) nextButton.disabled = maxIndex < 1;

    dots.forEach(function (dot, dotIndex) {
      dot.hidden = dotIndex > maxIndex;
      var isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function scrollSliderTo(section, index, options) {
    var track = section ? section.querySelector('[data-mmg-bagsmag-slider-track]') : null;
    if (!track) return;

    var maxIndex = getSliderMaxIndex(track);
    var shouldLoop = options && options.loop;
    var nextIndex = index;

    if (shouldLoop) {
      if (nextIndex > maxIndex) nextIndex = 0;
      if (nextIndex < 0) nextIndex = maxIndex;
    } else {
      nextIndex = Math.max(0, Math.min(nextIndex, maxIndex));
    }

    track.scrollTo({
      left: nextIndex * getSliderStep(track),
      behavior: 'smooth'
    });
    window.setTimeout(function () { updateDots(section); }, 260);
  }

  function setupSliderAutoplay(section) {
    if (!section || section.__mmgBagsmagAutoplayReady) return;
    section.__mmgBagsmagAutoplayReady = true;

    if (section.getAttribute('data-mmg-bagsmag-autoplay') !== 'true') return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var setPaused = function (isPaused) {
      section.__mmgBagsmagAutoplayPaused = isPaused;
    };

    section.addEventListener('mouseenter', function () { setPaused(true); });
    section.addEventListener('mouseleave', function () { setPaused(false); });
    section.addEventListener('focusin', function () { setPaused(true); });
    section.addEventListener('focusout', function () { setPaused(false); });

    section.__mmgBagsmagAutoplayTimer = window.setInterval(function () {
      if (!section.isConnected) {
        window.clearInterval(section.__mmgBagsmagAutoplayTimer);
        return;
      }
      if (section.__mmgBagsmagAutoplayPaused || document.hidden) return;

      var track = section.querySelector('[data-mmg-bagsmag-slider-track]');
      if (!track || getSliderMaxIndex(track) < 1) return;

      scrollSliderTo(section, getSliderIndex(track) + 1, { loop: true });
    }, 4200);
  }

  function initSliders(root) {
    (root || document).querySelectorAll('[data-mmg-bagsmag-slider]').forEach(function (section) {
      updateDots(section);
      setupSliderAutoplay(section);
    });
  }

  function setMobileMenu(header, isOpen) {
    if (!header) return;
    var toggle = header.querySelector('[data-mmg-bagsmag-menu-toggle]');
    var menu = header.querySelector('[data-mmg-bagsmag-mobile-menu]');

    header.classList.toggle('is-menu-open', isOpen);
    if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (menu) menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.classList.toggle('mmg-bagsmag-menu-open', isOpen);

    if (!isOpen) {
      resetMobileMenuDisclosures(header);
    }
  }

  function setDisclosure(item, isOpen, toggleSelector, contentSelector) {
    if (!item) return;
    var toggle = item.querySelector(toggleSelector);
    var content = item.querySelector(contentSelector);

    item.classList.toggle('is-open', isOpen);
    if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (content) content.hidden = !isOpen;
  }

  function closeDisclosures(container, exceptItem, itemSelector, toggleSelector, contentSelector) {
    if (!container) return;
    container.querySelectorAll(itemSelector).forEach(function (item) {
      if (item !== exceptItem) setDisclosure(item, false, toggleSelector, contentSelector);
    });
  }

  function resetMobileMenuDisclosures(root) {
    if (!root) return;
    root.querySelectorAll('.mmg-bagsmag-header__mobile-nav-item--has-dropdown').forEach(function (item) {
      setDisclosure(
        item,
        false,
        '[data-mmg-bagsmag-mobile-dropdown-toggle]',
        '[data-mmg-bagsmag-mobile-dropdown]'
      );
    });
    root.querySelectorAll('[data-mmg-bagsmag-mobile-group]').forEach(function (item) {
      setDisclosure(
        item,
        false,
        '[data-mmg-bagsmag-mobile-group-toggle]',
        '[data-mmg-bagsmag-mobile-group-content]'
      );
    });
  }

  function closeMobileMenus() {
    document.querySelectorAll('[data-mmg-bagsmag-header].is-menu-open').forEach(function (header) {
      setMobileMenu(header, false);
    });
  }

  function formatBagsmagVariantMoney(cents) {
    var settings = window.MinimogSettings || {};
    var moneyFormat = settings.money_format;

    if (typeof window.formatMmgDualMoney === 'function') {
      return window.formatMmgDualMoney(cents, moneyFormat);
    }

    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, moneyFormat);
    }

    return String((Number(cents) || 0) / 100);
  }

  function syncBagsmagProductCardVariant(optionNode) {
    if (!optionNode || !optionNode.matches('.mmg-bagsmag-product-card__swatches .m-product-option--node__label')) return;

    var card = optionNode.closest('.mmg-bagsmag-product-card');
    if (!card) return;

    var variantId = optionNode.getAttribute('data-variant-id');
    if (!variantId) return;

    var variantInput = card.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.setAttribute('value', variantId);
      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var optionPosition = optionNode.getAttribute('data-option-position');
    card.querySelectorAll('.mmg-bagsmag-product-card__swatches .m-product-option--node__label').forEach(function (node) {
      if (!optionPosition || node.getAttribute('data-option-position') === optionPosition) {
        node.removeAttribute('data-selected');
      }
    });
    optionNode.setAttribute('data-selected', 'true');

    var imageUrl = optionNode.getAttribute('data-variant-image');
    var image = card.querySelector('.m-product-card__main-image img');
    if (imageUrl && image) {
      image.src = imageUrl;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    }

    var price = Number(optionNode.getAttribute('data-variant-price') || 0);
    var compareAtPrice = Number(optionNode.getAttribute('data-variant-compare-at-price') || 0);
    var isAvailable = optionNode.getAttribute('data-variant-available') !== 'false';
    var priceWrapper = card.querySelector('.m-price');
    var onSale = compareAtPrice > price && price > 0;

    if (priceWrapper && price > 0) {
      priceWrapper.classList.toggle('m-price--on-sale', onSale);
      priceWrapper.classList.toggle('m-price--sold-out', !isAvailable);

      var regularPrice = priceWrapper.querySelector('.m-price__regular .m-price-item--regular');
      var salePrice = priceWrapper.querySelector('.m-price__sale .m-price-item--sale');
      var comparePrice = priceWrapper.querySelector('.m-price__sale .m-price-item--regular');

      if (regularPrice) regularPrice.innerHTML = formatBagsmagVariantMoney(price);
      if (salePrice) salePrice.innerHTML = formatBagsmagVariantMoney(price);
      if (comparePrice) comparePrice.innerHTML = formatBagsmagVariantMoney(onSale ? compareAtPrice : price);
    }

    var discountBadge = card.querySelector('.mmg-bagsmag-product-card__discount');
    if (discountBadge) {
      if (onSale) {
        discountBadge.textContent = '-' + Math.round((compareAtPrice - price) * 100 / compareAtPrice) + '%';
        discountBadge.classList.remove('!m:hidden');
        discountBadge.hidden = false;
      } else {
        discountBadge.classList.add('!m:hidden');
        discountBadge.hidden = true;
      }
    }

    var addButton = card.querySelector('.mmg-bagsmag-product-card__add');
    if (addButton) {
      addButton.disabled = !isAvailable;
    }
  }

  document.addEventListener('click', function (event) {
    var productCardOption = event.target.closest('.mmg-bagsmag-product-card__swatches .m-product-option--node__label');
    if (productCardOption) {
      syncBagsmagProductCardVariant(productCardOption);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var menuToggle = event.target.closest('[data-mmg-bagsmag-menu-toggle]');
    if (menuToggle) {
      var menuHeader = menuToggle.closest('[data-mmg-bagsmag-header]');
      var shouldOpen = menuHeader && !menuHeader.classList.contains('is-menu-open');
      closeMobileMenus();
      setMobileMenu(menuHeader, shouldOpen);
      return;
    }

    var menuClose = event.target.closest('[data-mmg-bagsmag-menu-close]');
    if (menuClose) {
      closeMobileMenus();
      return;
    }

    var mobileDropdownLabel = event.target.closest('.mmg-bagsmag-header__mobile-nav-item--has-dropdown > .mmg-bagsmag-header__mobile-nav-row .mmg-bagsmag-header__mobile-nav-link--primary');
    if (mobileDropdownLabel) {
      event.preventDefault();
      var labelDropdownItem = mobileDropdownLabel.closest('.mmg-bagsmag-header__mobile-nav-item--has-dropdown');
      var labelDropdownToggle = labelDropdownItem ? labelDropdownItem.querySelector('[data-mmg-bagsmag-mobile-dropdown-toggle]') : null;
      if (labelDropdownToggle) labelDropdownToggle.click();
      return;
    }

    var mobileDropdownToggle = event.target.closest('[data-mmg-bagsmag-mobile-dropdown-toggle]');
    if (mobileDropdownToggle) {
      event.preventDefault();
      var dropdownItem = mobileDropdownToggle.closest('.mmg-bagsmag-header__mobile-nav-item--has-dropdown');
      var mobileNav = mobileDropdownToggle.closest('.mmg-bagsmag-header__mobile-nav');
      var shouldOpenDropdown = dropdownItem && !dropdownItem.classList.contains('is-open');

      closeDisclosures(
        mobileNav,
        dropdownItem,
        '.mmg-bagsmag-header__mobile-nav-item--has-dropdown',
        '[data-mmg-bagsmag-mobile-dropdown-toggle]',
        '[data-mmg-bagsmag-mobile-dropdown]'
      );
      setDisclosure(
        dropdownItem,
        shouldOpenDropdown,
        '[data-mmg-bagsmag-mobile-dropdown-toggle]',
        '[data-mmg-bagsmag-mobile-dropdown]'
      );
      return;
    }

    var mobileGroupLabel = event.target.closest('[data-mmg-bagsmag-mobile-group] .mmg-bagsmag-header__mobile-dropdown-heading-link');
    if (mobileGroupLabel) {
      event.preventDefault();
      var labelGroupItem = mobileGroupLabel.closest('[data-mmg-bagsmag-mobile-group]');
      var labelGroupToggle = labelGroupItem ? labelGroupItem.querySelector('[data-mmg-bagsmag-mobile-group-toggle]') : null;
      if (labelGroupToggle) labelGroupToggle.click();
      return;
    }

    var mobileGroupToggle = event.target.closest('[data-mmg-bagsmag-mobile-group-toggle]');
    if (mobileGroupToggle) {
      event.preventDefault();
      var groupItem = mobileGroupToggle.closest('[data-mmg-bagsmag-mobile-group]');
      var mobileDropdown = mobileGroupToggle.closest('[data-mmg-bagsmag-mobile-dropdown]');
      var shouldOpenGroup = groupItem && !groupItem.classList.contains('is-open');

      closeDisclosures(
        mobileDropdown,
        groupItem,
        '[data-mmg-bagsmag-mobile-group]',
        '[data-mmg-bagsmag-mobile-group-toggle]',
        '[data-mmg-bagsmag-mobile-group-content]'
      );
      setDisclosure(
        groupItem,
        shouldOpenGroup,
        '[data-mmg-bagsmag-mobile-group-toggle]',
        '[data-mmg-bagsmag-mobile-group-content]'
      );
      return;
    }

    var mobileMenuLink = event.target.closest('[data-mmg-bagsmag-mobile-menu] a');
    if (mobileMenuLink) {
      closeMobileMenus();
      return;
    }

    var searchToggle = event.target.closest('[data-mmg-bagsmag-search-toggle]');
    if (searchToggle) {
      var header = searchToggle.closest('[data-mmg-bagsmag-header]');
      if (!header) return;
      var isOpen = header.classList.toggle('is-search-open');
      searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      var input = header.querySelector('[data-search-input]');
      if (isOpen && input) window.setTimeout(function () { input.focus(); }, 80);
      return;
    }

    if (!event.target.closest('[data-mmg-bagsmag-header]')) {
      document.querySelectorAll('[data-mmg-bagsmag-header].is-search-open').forEach(function (header) {
        header.classList.remove('is-search-open');
        var toggle = header.querySelector('[data-mmg-bagsmag-search-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    var button = event.target.closest('[data-mmg-bagsmag-hero-nav]');
    if (button) {
      var track = getTrack(button);
      if (!track) return;

      var direction = button.getAttribute('data-mmg-bagsmag-hero-nav') === 'next' ? 1 : -1;
      var maxIndex = getSliderMaxIndex(track);
      var nextIndex = getSliderIndex(track) + direction;

      if (nextIndex > maxIndex) nextIndex = 0;
      if (nextIndex < 0) nextIndex = maxIndex;

      track.scrollTo({
        left: nextIndex * getSliderStep(track),
        behavior: 'smooth'
      });
      return;
    }

    var sliderButton = event.target.closest('[data-mmg-bagsmag-slider-nav]');
    if (sliderButton) {
      var section = sliderButton.closest('[data-mmg-bagsmag-slider]');
      var sliderTrack = section ? section.querySelector('[data-mmg-bagsmag-slider-track]') : null;
      if (!sliderTrack) return;

      var sliderDirection = sliderButton.getAttribute('data-mmg-bagsmag-slider-nav') === 'next' ? 1 : -1;
      scrollSliderTo(section, getSliderIndex(sliderTrack) + sliderDirection, { loop: true });
      return;
    }

    var dot = event.target.closest('[data-mmg-bagsmag-slider-dot]');
    if (dot) {
      var dotSection = dot.closest('[data-mmg-bagsmag-slider]');
      var dotTrack = dotSection ? dotSection.querySelector('[data-mmg-bagsmag-slider-track]') : null;
      if (!dotTrack) return;

      var dotIndex = Number(dot.getAttribute('data-mmg-bagsmag-slider-dot') || 0);
      scrollSliderTo(dotSection, dotIndex);
    }
  });

  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track || !track.matches || !track.matches('[data-mmg-bagsmag-slider-track]')) return;
    var section = track.closest('[data-mmg-bagsmag-slider]');
    if (section) updateDots(section);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeMobileMenus();
    document.querySelectorAll('[data-mmg-bagsmag-header].is-search-open').forEach(function (header) {
      header.classList.remove('is-search-open');
      var toggle = header.querySelector('[data-mmg-bagsmag-search-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  window.addEventListener('resize', function () {
    window.clearTimeout(window.__mmgBagsmagResizeTimer);
    window.__mmgBagsmagResizeTimer = window.setTimeout(function () {
      initSliders(document);
    }, 120);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSliders(event.target);
  });

  function setupHeroAutoplay(section) {
  if (!section || section.__mmgBagsmagHeroAutoplayReady) return;
  section.__mmgBagsmagHeroAutoplayReady = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  section.__mmgBagsmagHeroAutoplayTimer = window.setInterval(function () {
    if (!section.isConnected) {
      window.clearInterval(section.__mmgBagsmagHeroAutoplayTimer);
      return;
    }

    if (document.hidden) return;

    var track = section.querySelector('[data-mmg-bagsmag-hero-track]');
    if (!track || getSliderMaxIndex(track) < 1) return;

    var nextIndex = getSliderIndex(track) + 1;
    var maxIndex = getSliderMaxIndex(track);

    if (nextIndex > maxIndex) nextIndex = 0;

    track.scrollTo({
      left: nextIndex * getSliderStep(track),
      behavior: 'smooth'
    });
  }, 5000);
}



  initSliders(document);

  document.querySelectorAll('[data-mmg-bagsmag-hero]').forEach(function (section) {
  setupHeroAutoplay(section);
});
})();
